import {useQuery} from "@tanstack/react-query";
import {invListMapInit} from "../state";
import {InvSearchParamType} from "../interface";
import {readInv} from "../../../../../api/inventory/InvApi";

type Props = {
    param: InvSearchParamType;
};

export const useReadInv = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readInv", param],
        queryFn: async () => await readInv(param),
        select: (res) => res?.data.result ?? invListMapInit,
    });

    return {data};
};
